import EmailForm from 'components/EmailForm/EmailFormComponent';
import EmailFormContainer from 'components/EmailForm/EmailFormContainer';

export { default as EmailForm } from 'components/EmailForm/EmailFormComponent';
export { default as EmailFormContainer } from 'components/EmailForm/EmailFormContainer';

export default {
  EmailForm,
  EmailFormContainer,
};
